import { render, staticRenderFns } from "./ModalCreatePromotion.vue?vue&type=template&id=5d71b1ca&scoped=true"
import script from "./ModalCreatePromotion.vue?vue&type=script&lang=js"
export * from "./ModalCreatePromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d71b1ca",
  null
  
)

export default component.exports